import { AuthenticatedLayout } from "../../../layouts/AuthenticatedLayout/AuthenticatedLayout";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { FC } from "react";
import { TaxSlipYearList } from "../../../components/TaxSlipYear";

export interface ITaxSlipYearListPage {}

export const TaxSlipYearListPage: FC<ITaxSlipYearListPage> = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Years"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[{text: 'Years', navigateTo: '/years/list'}]}
      mainContents={<TaxSlipYearList />}
    />
  );
};
